import 'toastr';
// import 'jquery-postcodes';
import ClipboardJS from 'clipboard';

$(function () {
    initPage();
});

global.initPage = function () {
    // @TODO - find another way of triggering this without Materialize
    $('.form-control').each(function(){
        const id = this.id;
        const value = this.value;

        if (!id || value === '') return;

        $('label[for="' + id + '"]').addClass('active');
    })

    // Data Picker Initialization
    // N.B targeting 'main' so datepicker isn't initialised on shadow datepicker elements
    $('main').bindDatePicker();

    //https://mdbootstrap.com/javascript/tooltips/
    $('[data-toggle="tooltip"]').tooltip();

    $('select[multiple="multiple"]').each(function () {
        $(this).prepend($('<option disabled>', {value:'', text:''}));
    });

    // Material Select Initialization
    // Documentation - https://mdbootstrap.com/docs/b4/jquery/forms/select/
    $('.mdb-select').materialSelect({ destroy: true });
    $('.mdb-select').materialSelect();

    $("#submit-apply-form").on('click', function (e) {
        e.preventDefault();
        $(this).trigger('submit');
        $(this).prop("disabled", true);
        toastr.clear();
    });

    //qualifications--block
    $('section.qualifications--block #add--qualification').on('click', function (e) {
        e.preventDefault();

        var lrsEvents = $('#lrs-learning-events');
        var prototype = $(lrsEvents).data('lrs-prototype');
        var index = $('#lrs-learning-events > .table--row').length;
        var newLine = prototype.replace(/__lrs_learning_event_proto__/g, index);

        lrsEvents.append(newLine);

        $('section.qualifications--block .remove--qualification').on('click', function (e) {
            e.preventDefault();
            $(this).parents('tr.table--row').remove();
        });

        lrsEvents.find('.flatpickr').last().bindDatePicker();
        lrsEvents.find('.mdb-select').last().materialSelect();
    });

    if ($('#lrs-learning-events > .table--row').length == 0) {
        $('#add--qualification').trigger('click');
    }

    //work--experience
    $('section.work--experience #add--experience').on('click', function (e) {
        e.preventDefault();

        var experiences = $('#experiences');
        var prototype = experiences.data('prototype');
        var index = $('#experiences > .simple--block').length;
        var newLine = prototype.replace(/__name__/g, index);

        experiences.append(newLine);

        $('section.work--experience .remove--experience').on('click', function (e) {
            e.preventDefault();
            $(this).parent().parent().remove();
        });

        experiences.find('.simple--block').last().find('.flatpickr').bindDatePicker();
    });

    if ($('#experiences > .simple--block').length == 0) {
        $('#add--experience').trigger('click');
    }

    forceSpacesInInputAndUpperCaseIt($('input[name$="[postcode]"]').next('input[type="search"]'), 6, 3);

    new ClipboardJS('.share-link');

    $('body').off('click.opportunityShareLink').on('click.opportunityShareLink', 'a', function(e) {
        if (e.currentTarget.classList.contains('share-link')) {
            e.preventDefault();

            toastr.info('Opportunity link has been copied to clipboard', {
                timeOut: 0,
                extendedTimeOut: 200
            });
        }
    });
}

global.toggleFormErrors = function (params) {
    // handles errors of single field
    var field = $('[name="' + params.fieldName + '"]');

    var error = field.prev('ul.error-control');
    $(error).remove();

    var formFieldErrors = '';

    if (typeof params.messages != 'undefined' && params.messages) {
        $.each(params.messages, function(key, message) {
            formFieldErrors += message + "\n";
        });
    }

    formFieldErrors = formFieldErrors.trim("\n");

    var ckeElement = $('#cke_' + $(field).attr('id'));

    if (ckeElement.length) {
        field = ckeElement;
    }

    var fieldNext = field.next();
    // if next field is search type and its ID contains current field's ID, it's going to be autocomplete
    if (field.attr('type') == 'hidden' && fieldNext.attr('type') == 'search' && fieldNext.attr('id').indexOf(field.attr('id')) > -1) {
        field = field.next();
    }

    if (window.toastr) toastr.error('<a href="#' + field.attr('id') + '" class="toastr-error">' + formFieldErrors + '</a>', params.fieldLabel);

    $('.toastr-error').one('click', e => e.preventDefault());
}

function forceSpacesInInputAndUpperCaseIt(textField, maxLength, spaceAfterPosition) {
    textField.on('keyup', function (e) {
        // don't catch backspace or delete hits
        if (e.keyCode == 8 || e.keyCode == 46) {
            return;
        }
        var textFieldLenght = textField.val().length;
        if (((textFieldLenght + 1) % (spaceAfterPosition + 1)) == 0) {
            textField.val(textField.val() + ' ');
        }
        if (textFieldLenght > maxLength) {
            textField.val(textField.val().slice(0, -1));
        }
        textField.val(textField.val().toUpperCase());
    });
}
